<template>
    <div class="duration">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5 border shadow-sm add-rounded">
                <h4 class="mb-3 font-weight-bold kova-text">How long do you need the developer to work on your project?</h4>
                <div class="text-left">
                    <label for="opt1" class="radio text-left">
                        <input type="radio" name="rdo" id="opt1" class="hidden" value="weeks" v-model="duration"/>
                        <span class="label"></span>1 to 4 weeks
                    </label><br />
                    
                    <label for="opt2" class="radio text-left">
                        <input type="radio" name="rdo" id="opt2" class="hidden" value="months" v-model="duration" />
                        <span class="label"></span>1 to 3 months
                    </label><br />
                    
                    <label for="opt3" class="radio text-left">
                        <input type="radio" name="rdo" id="opt3" class="hidden" value="moremonths" v-model="duration"/>
                        <span class="label"></span>3 to 6 months
                    </label><br />

                    <label for="opt4" class="radio text-left">
                        <input type="radio" name="rdo" id="opt4" class="hidden" value="manymonths" v-model="duration"/>
                        <span class="label"></span>Longer than 6 months
                    </label><br />
                    
                    <label for="opt5" class="radio text-left">
                        <input type="radio" name="rdo" id="opt5" class="hidden" value="hours" v-model="duration" />
                        <span class="label"></span>Few hours
                    </label>
                    <div class="ml-5" v-if="showInput">
                    How many hours? <input type="number" class="input" placeholder="6"/>
                    </div><br />
                    
                    <label for="opt6" class="radio text-left">
                        <input type="radio" name="rdo" id="opt6" class="hidden" value="not-certain" v-model="duration"/>
                        <span class="label"></span>Don't know yet
                    </label><br />
                </div>            
                <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right kova-text pt-3 mr-4 mb-5">
                <span>Skip <font-awesome-icon icon="step-forward"></font-awesome-icon></span>
            </div>
        </div>
        
        
 </div>
</template>
<script>
export default {
    name: 'duration',
    data(){
        return {
          countries: []
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push('dev-no')
        },
        skip(){
            this.$router.push('dev-no')
        }
    },
    mounted(){
        this.$http({
            method: 'GET',
            url:'https://ajayakv-rest-countries-v1.p.rapidapi.com/rest/v1/all',
            headers: {
                "x-rapidapi-host": "ajayakv-rest-countries-v1.p.rapidapi.com","x-rapidapi-key": "6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d"
            }
        }).then((response) => {
            this.countries = response.data
            // console.log(response.data)
        });
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}

@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>